<template>
    <div>
        <fade-transition origin="center" mode="out-in" :duration="250">
            <div class='v_v' v-show="show">
                <div class='player'>
                    <video ref="videoDom" class='v_playing' :src="vedioUrl" controls="controls" webkit-playsinline height='100%' width='100%'>
                        <source :src="vedioUrl" type="video/mp4">
                        您的浏览器不支持 video 标签。
                    </video>
                </div>
                <div class='close' @click="close">
                    <img src="https://cdncos.aigupiao.com/assets/pc/img/icon-close@2x.png" alt="" />
                </div>
            </div>
        </fade-transition>
    </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";
export default {
    name: 'videoplay',
    components: {
        FadeTransition,
    },
    props: {
        vedioUrl: {
            type: String,
            default: ''
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    created() {
        this.$nextTick(()=>{
             this.videoDom = this.$refs.videoDom
        })
    },
    methods: {
        open(uri) {
            this.vedioUrl = uri
            setTimeout(() => {
                this.videoDom.currentTime = 0
                this.videoDom.play();
                this.show = true
            }, 100);
        },
        close() {
            this.videoDom.pause();
            this.show = false
        }
    },

}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.v_v {
    position: fixed;
    top: 0;

    z-index: 9999;
    width: 100%;
    height: 100%;
    background-color: black;

    .player {
        position: absolute;
        width: 100%;
        height: 80%;
        top: 10%;
        .v_playing{
            width: 100%;
            height: 100%;
        }
    }
    
    .close {
        color: #fff;
        font-size: 50px;
        position: absolute;
        left: 10px;
        top: 10px;
        z-index: 9999;

        img {
            width: 40px;
            height: 40px;
        }
    }
}
</style>